<script lang="ts">
    import {onMount} from "svelte";
    import {swClient} from "../stores";
    import moment from 'moment';

    let last_scroll = 0;
    let showedItems = 15;
    let historyDiv;
    let historyEntries = [];
    let historyTypes = [];
    let uid = "";
    let type = "Campaign";

    onMount(async () => {
        $swClient.getLogsEntityNames().then(res => {
            historyTypes = res;
        })
    });

    async function getHistory() {
        $swClient.getLogs(type, uid).then(async (res) => {
            for (let i = 0; i < res.length; i++) {
                let element = res[i];
                if (element.source?.src === "authenticated-user") {
                    element.user = await $swClient.getUser(element.source.id)
                } else {
                    element.user = element.source?.src;
                }
            }
            historyEntries = res;
        });
    }

    async function wheelEvent(event) {
        if (event.deltaY > 0) {
            showedItems ++;
        }
    }

    async function handle_scroll(event) {
        if (historyDiv.scrollTop > last_scroll) {
            showedItems ++;
        }
        last_scroll = historyDiv.scrollTop;
    }

</script>

<style lang="scss">
    @import "../styles/variables.scss";

    #header {
        width: 100%;
        display: flex;
        justify-content: right;
        margin-bottom: 10px;
    }

    .history-line {
        background-color: $grey-light;

        &.bg-white {
        background-color: white;
        }

        &:not(.header) {
            &:hover {
                filter: drop-shadow(0px 2px 8px $orange);
            }
        }

        .history-case {
            width:  20%;
            overflow: hidden;
        }
    }
</style>


<div class="wrapper" bind:this={historyDiv} on:wheel={wheelEvent} on:scroll={handle_scroll}>
    <div class="sticky-menu">
        <div class="history-line columns header">
            <div class="history-case column">
                <select bind:value={type}>
                    {#each historyTypes as t}
                        <option value="{t}">{t}</option>
                    {/each}
                </select>
            </div>
            <div class="history-case column">
                <input type="text" placeholder="Uid de la ressource" bind:value="{uid}">
            </div>
            <div class="history-case column">
                <button class="button is-primary" on:click="{() => {getHistory()}}">
                    <i class="fas fa-search"></i>
                </button>
            </div>
        </div>
    </div>
    {#if historyEntries.length > 0}
        <div class="history-line columns header">
            <div class="history-case column">
                Utilisateur
            </div>
            <div class="history-case column">
                Date
            </div>
            <div class="history-case column">
                Champ
            </div>
            <div class="history-case column">
                Avant
            </div>
            <div class="history-case column">
                Après
            </div>
        </div>
        {#each historyEntries as entry, i}
            {#if i < showedItems}
                <div class="history-line columns {i%2 === 0 ? 'bg-white' : ''}">
                    <div class="history-case column">
                        {entry.user?.username} {entry.user?.name}
                    </div>
                    <div class="history-case column">
                        {moment(entry.when).format("DD/MM/YYYY HH:MM")}
                    </div>
                    <div class="history-case column">
                        {entry.diff?.field}
                    </div>
                    <div class="history-case column">
                        {entry.diff?.before}
                    </div>
                    <div class="history-case column">
                        {entry.diff?.after}
                    </div>
                </div>
            {/if}
        {/each}
    {:else}
        <h1>Aucun historique disponible</h1>
    {/if}
</div>
